export default [
  {
    id: "dwelling-1",
    title: "Tranquilidad total",
    tag: "Tarifa del",
    tint: "mint",
    rate: "12%",
    text: "Pago canon primeros 5 días del mes",
    text_0: "Pago de asistencia",
    text_1: "Bolsa Coninsa Te Cuida por $500.000"
  },
  {
    id: "dwelling-2",
    title: "Plus",
    tag: "Tarifa del",
    tint: "blue",
    rate: "11%",
    text: "Pago canon primeros 10 días del mes",
    text_0: "Plan asistencias",
    text_1: ""
  },
  {
    id: "dwelling-3",
    title: "Esencial",
    tag: "Tarifa del",
    tint: "blue",
    rate: "10.5%",
    text: "Pago canon último día del mes",
    text_0: "Administración interal del inmueble",
    text_1: ""
  }
]
